export default "__VITE_ASSET__3c9f7b28__"